/**
 * Renders portfolio-share + fund-count label with an SVG dot separator.
 *
 * Belongs here: label chrome for preference headers / rows.
 * Does not belong here: computing share/fund strings (see setup/config).
 */
import type { PortfolioFundLabel } from '../../setup/config'

const PORTFOLIO_FUND_SEPARATOR_DOT = (
  <svg xmlns="http://www.w3.org/2000/svg" width="3" height="3" viewBox="0 0 3 3" fill="none" aria-hidden>
    <circle cx="1.5" cy="1.5" r="1.5" fill="#232323" />
  </svg>
)

export function FundLabelWithSeparator({ label }: { label: PortfolioFundLabel }) {
  if (label.kind === 'plain') return <>{label.text}</>
  return (
    <>
      <span>{label.portfolioPart}</span>
      <span
        className="inline-flex shrink-0 items-center justify-center px-[6px] mt-[2px]"
        aria-hidden
      >
        {PORTFOLIO_FUND_SEPARATOR_DOT}
      </span>
      <span>{label.fundPart}</span>
    </>
  )
}
